import React from 'react'
import './index.css';

interface SwitchProps{
    onChange: Function,
    defaultChecked?: boolean
}

const ToggleSwitch: React.FC<SwitchProps> = (props: SwitchProps) => {
    return (
        <label className='switch'>
            <input type="checkbox" checked={props.defaultChecked} onChange={event => props.onChange(event.target.checked)}/>
            <span className='slider'></span>
        </label>
    )
}

export default ToggleSwitch